import { render, staticRenderFns } from "./MessageWidgetUserAvatar.vue?vue&type=template&id=1efbbbbf&"
import script from "./MessageWidgetUserAvatar.vue?vue&type=script&lang=js&"
export * from "./MessageWidgetUserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports